import { create } from 'zustand';

// ModMed PM integration state (mirrors veradigmPMStore). Initialized in App.jsx
// on login when org.settings.uses_modmed_billing is set.
const initialState = {
  usesModMedBilling: false,
  configured: false,
  // usesModMedBilling AND a config row exists AND config.is_active
  active: false,
  configLoaded: false,
  // Prism organization_location ids whose encounters post to ModMed
  locationIds: [],
  isLoading: false,
  error: null,
};

export const useModMedStore = create((set, get) => ({
  ...initialState,

  setUsesModMedBilling: (enabled) => set({ usesModMedBilling: enabled }),

  setConfig: (config) => {
    const usesModMedBilling = get().usesModMedBilling;
    set({
      configured: !!config,
      active: usesModMedBilling && !!config && config.is_active === true,
      configLoaded: true,
      locationIds: Array.isArray(config?.location_ids) ? config.location_ids : [],
    });
  },

  setLoading: (loading) => set({ isLoading: loading }),
  setError: (error) => set({ error }),

  reset: () => set(initialState),
}));
